import React from "react";

import {MuiIcon, MuiIconExternalProps} from "./MuiIcon";

export const SettingsIcon = (props: MuiIconExternalProps) => {
    return (
        <MuiIcon {...props}
        >{'\ue8b8'}</MuiIcon>
    );
}
